import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { GoogleTranslate } from "@/types";
import { fetchGoogleTranslateIntergration } from "./thunk";
export interface GoogleTranslateState {
  googleTranslateIntegration: GoogleTranslate;
  isEhqPfe: false;
}
const initialState = {
  googleTranslateIntegration: {
    siteId: "",
    position: "",
    includedLanguages: ""
  },
  isEhqPfe: false
};

export const googleTranslateIntegrationSlice = createSlice({
  name: "googleTranslate",
  initialState,
  reducers: {
    showGoogleTranslate: (state, action) => {
      state.isEhqPfe = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[googleTranslateIntegrationSlice.name]
        };
      })
      .addCase(fetchGoogleTranslateIntergration.pending, (state) => {
        state = initialState;
      })
      .addCase(fetchGoogleTranslateIntergration.fulfilled, (state, action) => {
        state.googleTranslateIntegration = action.payload;
      })
      .addCase(fetchGoogleTranslateIntergration.rejected, (state) => {
        state = initialState;
      });
  }
});

export const { showGoogleTranslate } = googleTranslateIntegrationSlice.actions;
